import React from 'react';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import { Box } from '@mui/material';

export const SearchPageContainer: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;
  const newUiStyles = {
    paddingBottom: spaces.xxxxl,
    paddingTop: 0,
    backgroundColor: palette.common.white,
    minHeight: 'calc(100vh - 48px)',  // 48px is $top-bar-height
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    gap: spaces.xl,
    display: 'flex',
    flexDirection: 'column',
  };

  return <Box sx={newUiStyles}>{children}</Box>;
};
